import { render, staticRenderFns } from "./EthicsCodexModal.vue?vue&type=template&id=f1705496"
import script from "./EthicsCodexModal.vue?vue&type=script&lang=ts"
export * from "./EthicsCodexModal.vue?vue&type=script&lang=ts"
import style0 from "./EthicsCodexModal.vue?vue&type=style&index=0&id=f1705496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports